import { useEffect, useRef, useState } from "react";
import "./index.scss";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faFlask,
  faPenNib,
} from "@fortawesome/free-solid-svg-icons";

function Navbar() {
  const [isActive, setIsActive] = useState(false);
  const buttonRef = useRef(null);

  const toggleActiveClass = () => {
    setIsActive(!isActive);
  };

  const removeActive = () => {
    setIsActive(false);
  };

  useEffect(() => {
    if (!isActive) return;
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      setIsActive(false);
      buttonRef.current?.focus();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isActive]);

  return (
    <nav className="navbar" aria-label="Main">
      <a href="/" className="logo" aria-label="Chirag Boghara, home">
        {"<Chirag Boghara/>"}
      </a>

      {/* Before the menu in the DOM so Tab moves from the button into the open menu */}
      <button
        type="button"
        ref={buttonRef}
        className={isActive ? "hamburger active" : "hamburger"}
        onClick={toggleActiveClass}
        aria-label={isActive ? "Close menu" : "Open menu"}
        aria-expanded={isActive}
        aria-controls="nav-menu"
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      <ul id="nav-menu" className={isActive ? "navMenu active" : "navMenu"}>
        <li onClick={removeActive}>
          <NavLink to="/" className={({isActive})=> isActive ? "activeLink" : "navLink"}>
            {isActive && <FontAwesomeIcon icon={faHouse} size="lg"/>}
            Home
          </NavLink>
        </li>
        <li onClick={removeActive}>
          <NavLink to="/about" className={({isActive})=> isActive ? "activeLink" : "navLink"}>
            {isActive && <FontAwesomeIcon icon={faUser} size="lg"/>}
            About
          </NavLink>
        </li>
        <li onClick={removeActive}>
          <NavLink to="/projects" className={({isActive})=> isActive ? "activeLink" : "navLink"}>
            {isActive && <FontAwesomeIcon icon={faFlask} size="lg"/>}
            Projects
          </NavLink>
        </li>
        <li onClick={removeActive}>
          <NavLink to="/blog" className={({isActive})=> isActive ? "activeLink" : "navLink"}>
            {isActive && <FontAwesomeIcon icon={faPenNib} size="lg"/>}
            Blog
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
